/* eslint-disable no-param-reassign, max-params */

const initialState = {
  /**
   * Array of
   * {
   *   title: String,
   *   error: String,
   *   details: Optional Array of {
   *     title: String,
   *     description: String
   *   }
   * }
   */
  stack: [],
  errorsEnabled: false
};

const errorsModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    stack: state => state.stack,
    errorsEnabled: state => state.errorsEnabled
  },

  mutations: {
    addNewError(state, error) {
      const errorExists = state.stack.find(e => e.error === error.error && e.title === error.title);
      if (!errorExists) {
        state.stack.push(error);
      }
    },
    clearErrorByIndex(state, index) {
      state.stack.splice(index, 1);
    },
    enableErrors(state) {
      state.errorsEnabled = true;
    }
  }
};

export default errorsModule;
